module.exports = __webpack_public_path__ + "static/media/CHEVROLET.cbbcaee9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/carBrands/CHEVROLET.png
 ** module id = 1657
 ** module chunks = 0
 **/